import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Divider,
  Fade,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import { Cancel, FilterNone } from '@mui/icons-material';
import { COLOR_BLACK_HAZE, COLOR_BLACK_PERL, COLOR_CARNATION } from 'popTheme';
import { ResourceCardExpanded } from './ResourceCardExpanded';
import { sendClientAnalytics } from '../../redux/sagas/clientAnalyticsSaga';
import { useDispatch } from 'react-redux';
import { AuditEventAction, createClientAnalytics } from '../../ClientAnalytics';

export const ResourceCard = ({ data, color }) => {
  const intl = useIntl();
  const messages = defineMessages({
    resourceCardLearnMore: {
      id: 'resource.card.learn.more',
      defaultMessage: 'Learn More',
      description: 'Label for the Learn More button',
    },
  });

  const headerImage = `data:image/jpeg;base64,${data.headerImage}`;
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    dispatch(
      sendClientAnalytics(
        createClientAnalytics(
          AuditEventAction.EXPAND_RESOURCE.category,
          AuditEventAction.EXPAND_RESOURCE.action,
          {
            resource: data.title,
          },
        ),
      ),
    );
  };
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const onResourceLinkClick = () => {
    dispatch(
      sendClientAnalytics(
        createClientAnalytics(
          AuditEventAction.LAUNCH_RESOURCE.category,
          AuditEventAction.LAUNCH_RESOURCE.action,
          {
            resource: data.title,
          },
        ),
      ),
    );
  };

  return (
    <>
      <Card
        sx={{
          width: { xs: '21rem', md: '22.5rem', xl: '24.375rem' },
          maxWidth: { xs: '21rem', md: '22.5rem', xl: '24.375rem' },
          height: { xs: '26.1875rem', md: '28.6875rem', xl: '29.6875rem' },
          borderRadius: '0.75rem',
          background: color,
          mb: '2rem',
        }}
      >
        <CardActionArea href={data.link} target="_blank" onClick={onResourceLinkClick}>
          <CardMedia
            sx={{
              height: { xs: '11.5625rem', sm: '11.8125rem', md: '12.6875rem', xl: '13.6875rem' },
            }}
            image={headerImage}
            title={data.title}
          />
        </CardActionArea>
        <CardContent sx={{ height: '35%' }}>
          <Typography gutterBottom variant="h4" color={COLOR_BLACK_PERL}>
            {data.title}
          </Typography>
          <Typography variant="subtitle2" color={COLOR_BLACK_PERL}>
            {data.tagLine}
          </Typography>
        </CardContent>
        <Divider variant="middle" sx={{ bgcolor: COLOR_BLACK_PERL }} />
        <CardActions sx={{ height: '10%' }}>
          <Button
            onClick={handleOpen}
            size="small"
            endIcon={<FilterNone />}
            data-testid="learn-more-button"
            sx={{ color: COLOR_BLACK_PERL, m: 'auto' }}
          >
            {intl.formatMessage(messages.resourceCardLearnMore)}
          </Button>
        </CardActions>
      </Card>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        data-testid="expanded-resource-modal"
      >
        <Fade in={open}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <IconButton
              disableRipple
              size="small"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                zIndex: 1,
                top: { xs: '0.5rem', lg: '0.5rem' },
                right: { xs: '1.25rem', lg: '0.5rem' },
                width: '1.25rem',
                height: '1.25rem',
                bgcolor: COLOR_CARNATION,
                color: COLOR_BLACK_HAZE,
              }}
            >
              <Cancel />
            </IconButton>
            <ResourceCardExpanded id={data.id} color={color} />
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
